<template>
  <a-modal
    :open="isVisible"
    title="Выберите проверяющего"
    centered
    ok-text="Подтвердить"
    cancel-text="Отмена"
    :confirm-loading="isLoading"
    @ok="handleChangeReviewer"
    @cancel="close">
    <a-select
      v-model:value="newReviewerId"
      :filter-option="filterName"
      show-search
      :style="{ width: '100%' }">
      <a-select-option
        v-for="(user) in simpleReviewersList"
        :key="user.id"
        :value="user.id">
        {{ user.name }}
      </a-select-option>
    </a-select>
  </a-modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { sortBy } from 'lodash';
import { searchForSimpleUsersListSelect } from '@/utils/searchForSimpleUsersListSelect';

const props = defineProps({
  planId: {
    default: () => null,
    type: Number,
  },
  action: {
    default: () => 'crm/changeCrmPlanReviewer',
    type: String,
  },
});

const emit = defineEmits(['changeReviewerSuccess']);

const store = useStore();

store.dispatch('crm/getSimpleUsersList');

const newReviewerId = ref(null);

const simpleReviewersList = computed(() => sortBy(store.getters['crm/simpleReviewersList'], ['name']));

const filterName = (input, option) => searchForSimpleUsersListSelect(simpleReviewersList, input, option);

const isVisible = computed(() => store.state.crm.modals.changeReviewer.isVisible);
const isLoading = computed(() => store.state.crm.modals.changeReviewer.isLoading);
const close = () => store.commit('crm/setChangeReviewerModalVisibility', false);

const handleChangeReviewer = async () => {
  await store.dispatch(props.action, { id: props.planId, reviewerId: newReviewerId.value });
  emit('changeReviewerSuccess');
};
</script>
